import "./header.css";

function Header() {
  return (
    <div id="home" className="container header-container">
      <h3>
        <div className="im"> I<span>'</span>m</div>
        Adas
      </h3>
      <h2 className="header-subtitle">Full Stack Developer</h2>
    </div>
  );
}

export default Header;
